import React, { useEffect } from 'react';
import {
	Alert,
	Autocomplete,
	Grid,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { registerSubBias } from '../../../actions/biases';
import { getCatalogList } from '../../../actions/catalogs';
import { HeaderSection } from './BiasInfo';
import { sortSizes } from '../../../helpers/utils';

export const SubBiasForm = ({
	bias = null,
	refresh = null,
	setUsingForm = null,
	subbiasesList = null,
}) => {
	// Define state to know if it's loading or not
	const [isLoading, setIsLoading] = useState(false);

	// Form
	const [units, setUnits] = useState('');
	const [size, setSize] = useState(null);
	const [sizes, setSizes] = useState([]);

	// Message
	const [msgText, setMsgText] = useState('');
	const [isMsgSent, setIsMsgSent] = useState(null);

	// Current user
	const { user } = useSelector((state) => state);

	// Feedback message control
	const feedbackMessage = (ok, msg, time = 2000, doNotLeave = true) => {
		setIsMsgSent(ok);
		setMsgText(msg);
		refresh();
		setTimeout(() => {
			setMsgText('');
			setIsMsgSent(null);
			setIsLoading(false);
			if (doNotLeave) {
				setUsingForm(false);
			}
		}, time);
	};

	// Handle submit
	const handleSubmit = () => {
		if (units?.length > 0 && size) {
			const formData = {
				name: '',
				units: parseInt(units),
				size: sizes.find((item) => item.name === size).id,
				bias: parseInt(bias.id),
				created_by: user.id,
				delivery_forecast: bias.order.delivery_date,
			};

			const { ok = false, msg = 'Error' } = itCanBeRegistered(
				parseInt(units),
				size
			);

			if (ok) {
				registerSubBias(formData)
					.then(() => {
						feedbackMessage(true, 'Talla agregada correctamente.');
						refresh()
					})
					.catch((error) => {
						feedbackMessage(false, 'No se pudo agregar la talla.');
					});
			} else {
				feedbackMessage(false, msg, 5000, false);
			}
		} else {
			feedbackMessage(false, 'Error en el formulario', 2000, false);
		}
	};

	// Check if it can be registered
	const itCanBeRegistered = (newUnits, newSize) => {
		if (newUnits === 0) {
			return { ok: false, msg: 'Las unidades no pueden ser 0' };
		}
		let unitsCounter = 0;
		subbiasesList.forEach((item) => (unitsCounter += item.units));
		const sizes = subbiasesList.map((item) => item.size);
		if (sizes.includes(newSize)) {
			return { ok: false, msg: 'Talla repetida' };
		}
		const newCounter = newUnits + unitsCounter;
		return {
			ok: newCounter <= bias.units,
			msg: 'El número de unidades requeridas sobrepasa las unidades de la orden.',
		};
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	useEffect(() => {
		getCatalogList('size').then(({ data }) => {
			setSizes(data.results);
		});
	}, []);

	return (
		<div style={{ padding: '25px' }}>
			{/* HEADER */}
			<HeaderSection text='Nueva talla' />
			{isMsgSent !== null && msgText.length > 0 && (
				<Alert
					severity={isMsgSent ? 'success' : 'error'}
					style={{ margin: '30px 0 0 0' }}
				>
					{msgText}
				</Alert>
			)}
			<br />
			{/* SUBHEADER */}
			<Typography variant='p' gutterBottom>
				Complete el formulario para agregar una nueva talla
			</Typography>

			<hr />

			{/* FORM */}
			<Grid container spacing={2}>
				<Grid item xs={6}>
					<Autocomplete
						required
						style={{ marginTop: '-17px' }}
						fullWidth
						value={size}
						onChange={(_, value) => {
							setSize(value);
						}}
						options={sortSizes(sizes, 'name').map((item) => item.name)}
						renderInput={(params) =>
							TextFieldComponent(params, 'Tallas')
						}
					/>
				</Grid>

				<Grid item xs={6}>
					<TextField
						required
						fullWidth
						label='Unidades'
						value={units}
						onChange={({ target }) => setUnits(target.value)}
					/>
				</Grid>

				<Grid item xs={6}>
					<LoadingButton
						fullWidth
						color='error'
						onClick={() => setUsingForm(false)}
						variant='contained'
						loading={false}
					>
						Cancelar
					</LoadingButton>
				</Grid>

				<Grid item xs={6}>
					<LoadingButton
						fullWidth
						variant='contained'
						loading={isLoading}
						// style={{ backgroundColor: '#143f6c' }}
						onClick={handleSubmit}
					>
						Crear
					</LoadingButton>
				</Grid>
			</Grid>
		</div>
	);
};
